window.customElements.define('lazyloaded-video',
  class LazyLoadedVideo extends HTMLElement {
    connectedCallback() {
      this.observer = null;
      this.initObserver();
    }

    initObserver() {
      const video = this.querySelector('video');
      if (!video) return;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadVideo(entry.target);
              observer.unobserve(entry.target);
            }
          });
        });

        this.observer.observe(video);
      } else {
        this.loadVideo(video);
      }
    }

    loadVideo(video) {
      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach(source => {
        source.src = source.dataset.src;
      });
      video.load();
      video.play();
      this.classList.remove('lazy');
    }
  }
);
